/**
 * @description 判读是否为正确URL
 * @param path
 * @returns {boolean}
 */
export function isExternal(path) {
    if (new RegExp(/\s+/g).test(path)) {
        return false
    } else {
        return /^(https?:|mailto:|tel:)/.test(path)
    }
}

/**
 * @description 是否含特殊字符
 * @param newName
 * @returns {boolean}
 */
export function isExtName(newName) {
    let flag = new RegExp("[*/\\\\:?\"<>|]")
    return flag.test(newName);
}

/**
 * @description 是否前缀、后缀空格
 * @param suffix
 * @returns {boolean}
 */

/**
 * @description 是否含特殊字符
 * @returns {boolean}
 */
export const externalName = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入证据名称'))
    } else {
        if (new RegExp("[*/\\\\:?\"<>|]").test(value)) {
            callback(new Error('证据名称不支持以下字符 */\\:?"<>| '))
        } else {
            callback()
        }
    }
}

/**
 * @description 判读是否为正确URL
 * @param path
 * @returns {boolean}
 * @param {string} path
 */
export const externalUrl = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入网址'))
    } else {
        if (!/^(https?:|mailto:|tel:)/.test(value)) {
            callback(new Error('请输入正确网址'))
        } else {
            callback()
        }
    }
}

export function isEmptyName(suffix) {
// Js 判断后缀
    String.prototype.endsWith = function (suffix) {
        console.log(this.indexOf(suffix, this.length - suffix.length) !== -1)
    };
    // Js 判断前缀
    if (typeof String.prototype.startsWith != 'function') {
        // see below for better implementation!
        String.prototype.startsWith = function (str) {
            return this.indexOf(str) == 0;
        };
    }
}

/**
 * @description 申请人校验
 * @returns {boolean}
 */
export const isApplicantPassName = (rule, value, callback) => {
    if (value === '' || value === undefined) {
        callback(new Error('申請者の氏名/社名を入力してください'))
    } else if (value.length > 30) {
        callback(new Error('申请人名称不超过30字符'))
    } else {
        callback()
    }
}


/**
 * @description 判读是否为正确微信公众号URL
 * @param path
 * @returns {boolean}
 */
export function isWxArticleUrl(path) {
    if (new RegExp(/\s+/g).test(path)) {
        return false
    } else {
        return /^http[s]?:\/\/mp.weixin.qq.com\/s/g.test(path)
    }
}





